export const reviews = [
  {
    id: 'r1',
    name: '李女士',
    avatar: '',
    rating: 5,
    content: '在愽彩糖果买了好几次了，品质真的很稳定！上次买的臻选礼盒送客户，客户特别满意，还特意问我在哪买的。包装精美，糖果味道也好，以后送礼就认准你家了！',
    date: '2026-07-30',
    product: '臻选糖果礼盒套装',
  },
  {
    id: 'r2',
    name: '王先生',
    avatar: '',
    rating: 5,
    content: '开甜品店一直在找靠谱的散装糖果供应商，试了好几家最后选了愽彩。品质没话说，价格也公道，最主要是品种齐全，一次就能搞定所有采购需求，省心！',
    date: '2026-07-25',
    product: '散装混合水果糖5斤装',
  },
  {
    id: 'r3',
    name: '张妈妈',
    avatar: '',
    rating: 5,
    content: '儿子生日派对买的小熊软糖和棒棒糖，小朋友们都抢着吃！糖果造型可爱，味道也不是那种劣质香精味，大人也放心。下次派对还会回购！',
    date: '2026-07-18',
    product: '小熊造型果汁软糖',
  },
  {
    id: 'r4',
    name: '陈小姐',
    avatar: '',
    rating: 4,
    content: '巧克力的品质出乎意料的好！本来以为这个价位的进口巧克力会很一般，结果口感非常丝滑，可可味浓郁。唯一建议就是包装可以再精致一点。',
    date: '2026-07-12',
    product: '进口巧克力夹心糖',
  },
  {
    id: 'r5',
    name: '赵老板',
    avatar: '',
    rating: 5,
    content: '作为批发客户，我必须给愽彩糖果点个赞。从下单到发货速度很快，糖果新鲜度好，包装严实没有破损。已经是老客户了，推荐给了好几个同行。',
    date: '2026-07-05',
    product: '散装什锦软糖10斤装',
  },
  {
    id: 'r6',
    name: '刘小姐',
    avatar: '',
    rating: 5,
    content: '买的节日限定大礼包，超级大一盒！里面有各种糖果和巧克力，拆开的时候满满仪式感。送给爸妈当新年礼物，他们开心得跟小孩一样，哈哈。',
    date: '2026-06-28',
    product: '节日限定糖果大礼包',
  },
];